export const labelMappings = {
  underweight: "Underweight",
  normal: "Normal",
  overweight: "Overweight",
  obese: "Obese",
  "Elementary education (Basic reading and writing)": "elementary",
  "Primary education (Basic studies)": "primary",
  "Secondary education or vocational training": "secondary",
  "University education (Bachelor’s degree)": "university",
  "Postgraduate education (Master’s degree, PhD)": "postgraduate",
  "I am currently a regular smoker": "regular",
  "I am a former smoker": "former",
  "I have never smoked": "never",
};

export const getChartColor = () => {
  const colors = ["#3498db", "#9b59b6", "#1abc9c", "#e9967a"];
  return colors;
};
